export default __webpack_public_path__ + "static/media/objects-sensing-introversion.f4cda208.png";